import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Customer } from '../customer.model';
import { Mandoob } from './mandoob.model';

@Injectable({
  providedIn: 'root'
})
export class MandoobService {


  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

  }

  getAll() {
    return this.http.get<Customer[]>(this.global.APIURL + "users/mandoobslist");
  }

  getById(id: number) {
    return this.http.get<Mandoob>(this.global.APIURL + "mandoob/" + id);
  }

  Create(mandoob: object) {
    return this.http.post(this.global.APIURL + "mandoob", mandoob)
  }

  Update(mandoob: any) {
    return this.http.put(this.global.APIURL + "mandoob", mandoob)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "mandoob/" + id)
  }
}
